import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GA4IntegrationStatus = ({ isConnected, lastSyncTime, customEvents }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Google Analytics 4</h3>
          <p className="text-xs md:text-sm text-muted-foreground">Integration status and tracking</p>
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-medium ${isConnected ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'}`}>
          {isConnected ? 'Connected' : 'Disconnected'}
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name={isConnected ? 'CheckCircle2' : 'XCircle'} size={18} className={isConnected ? 'text-success' : 'text-destructive'} />
            <span className="text-sm text-foreground">Connection Status</span>
          </div>
          <span className="text-sm font-medium text-foreground">{isConnected ? 'Active' : 'Inactive'}</span>
        </div>
        
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="RefreshCw" size={18} className="text-accent" />
            <span className="text-sm text-foreground">Last Sync</span>
          </div>
          <span className="text-sm font-medium text-foreground">{lastSyncTime}</span>
        </div>
        
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="Activity" size={18} className="text-accent" />
            <span className="text-sm text-foreground">Custom Events</span>
          </div>
          <span className="text-sm font-medium text-foreground">{customEvents} tracked</span>
        </div>
        
        <div className="pt-2">
          <p className="text-xs text-muted-foreground mb-3">Tracked Events:</p>
          <div className="flex flex-wrap gap-2">
            {['catalog_view', 'page_flip', 'hotspot_click', 'buy_button_click', 'share_catalog']?.map((event) => (
              <span key={event} className="px-2 py-1 bg-muted rounded text-xs text-foreground font-mono">
                {event}
              </span>
            ))}
          </div>
        </div>
        
        <div className="pt-4">
          <Button variant="outline" iconName="Settings" iconPosition="left" fullWidth>
            Configure GA4 Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GA4IntegrationStatus;